module.exports = __webpack_public_path__ + "img/LogoDashboard-26.32e84228.svg";